import { useEffect, useState } from "react";

import breakpoints from "@/themes/base/breakpoints";
import { TabsOrientation } from "@/types/tab.types";

const useTabsOrientation = (): TabsOrientation => {
  const [tabsOrientation, setTabsOrientation] = useState<TabsOrientation>("horizontal");

  useEffect(() => {
    function handleTabsOrientation() {
      const isSmallSize = window.innerWidth < breakpoints.values.sm;
      setTabsOrientation(isSmallSize ? "vertical" : "horizontal");
    }

    window.addEventListener("resize", handleTabsOrientation);

    // Run on mount to set initial orientation
    handleTabsOrientation();

    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, []);

  return tabsOrientation;
};

export default useTabsOrientation;
